import { combineReducers } from 'redux';
import { omit } from 'lodash';

import {
  FETCH_PURCHASE,
  FETCH_CLAIM_PURCHASE,
  FETCH_COMMIT_TO_PURCHASE,

  SET_CURRENT_MEMBERSHIP,

  FETCH_PURCHASE_MEMBERSHIPS,
  WITHDRAW_FROM_PURCHASE,
  REMOVE_MEMBERSHIP,
  FETCH_USER_PURCHASES,
} from '../actions/index';
import {
  normalizePurchase,
  normalizePurchases,
} from './schemas';

const setMembershipsFromPurchase = (state, action) => {
  const { payload } = action;
  const { entities: { memberships } } = normalizePurchase(payload);

  return {
    ...state,
    ...memberships,
  };
};

const addBulkMemberships = (state, action) => {
  const { payload: { purchases } } = action;
  const { entities: { memberships } } = normalizePurchases(purchases);

  return {
    ...state,
    ...memberships,
  };
};

const addMembership = (state, action) => {
  const { payload: membership } = action;
  return {
    ...state,
    [membership.id]: { ...membership },
  };
};

const updateMembership = (state, action) => {
  const { payload } = action;

  return {
    ...state,
    [payload.id]: payload,
  };
};

const removeMembership = (state, action) => {
  const { payload } = action;
  const { id } = payload;

  return {
    ...omit(state, [id]),
  };
};

const membershipsById = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PURCHASE:
    case FETCH_PURCHASE_MEMBERSHIPS:
    case FETCH_CLAIM_PURCHASE:
      return setMembershipsFromPurchase(state, action);
    case FETCH_COMMIT_TO_PURCHASE:
      return addMembership(state, action);
    case WITHDRAW_FROM_PURCHASE:
      return updateMembership(state, action);
    case REMOVE_MEMBERSHIP:
      return removeMembership(state, action);
    case FETCH_USER_PURCHASES:
      return addBulkMemberships(state, action);
    default:
      return state;
  }
};

const currentMembership = (state = null, action) => {
  switch (action.type) {
    case SET_CURRENT_MEMBERSHIP:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  byId: membershipsById,
  current: currentMembership,
});



// WEBPACK FOOTER //
// ./src/reducers/memberships.reducer.js